/**
 * @deprecated This file is deprecated. Import from './themes/registry' instead.
 * Will be removed in 2 sprints (after migration period).
 *
 * Migration guide:
 * - Old: `import { getTheme } from '@/styles/colors/palettes'`
 * - New: `import { getTheme, ThemeId } from '@/styles/colors/themes'`
 */

import {
  getTheme as getThemeFromRegistry,
  getAllThemes,
  type ThemeName,
  REGISTERED_THEMES,
} from './themes/registry';
import { ThemeColors } from './types';
import { logger } from '@/utils/logger';

/**
 * Theme collection (deprecated)
 * @deprecated Use getAllThemes() from './themes/registry' instead
 */
export const themes: Record<ThemeName, ThemeColors> = Object.fromEntries(
  Object.entries(REGISTERED_THEMES).map(([name, def]) => [
    name,
    {
      name: name as ThemeName,
      palette: def.palette,
    },
  ])
) as Record<ThemeName, ThemeColors>;

/**
 * Get a specific theme's colors
 * @deprecated Use getTheme from './themes/registry' instead
 */
export const getTheme = (themeName: ThemeName): ThemeColors => {
  if (process.env.NODE_ENV === 'development') {
    logger.warn(
      '[DEPRECATED] getTheme from palettes.ts is deprecated. ' +
        'Import from "./themes/registry" instead. This will be removed in 2 sprints.'
    );
  }
  const theme = getThemeFromRegistry(themeName);
  return {
    name: themeName,
    palette: theme.palette,
  };
};

/**
 * Get all available theme names
 * @deprecated Use getAllThemes from './themes/registry' instead
 */
export const getThemeNames = (): ThemeName[] => {
  if (process.env.NODE_ENV === 'development') {
    logger.warn(
      '[DEPRECATED] getThemeNames from palettes.ts is deprecated. ' +
        'Import from "./themes/registry" instead. This will be removed in 2 sprints.'
    );
  }
  return getAllThemes().map(t => t.name);
};
